import React from 'react'
import ShipItem from './ShipItem'

class ShipItems extends React.Component {
    render() {
        const {item, ...rest} = this.props
        const {products} = item

        const newProducts = products.filter(_item => _item.status !== 'cancelled')
        const countProducts = newProducts.length

        return (
            <div className='PrintItems'>
                {
                    newProducts.map((product, index) => {
                        return <ShipItem {...rest} key={product._id} item={item} product={product}
                                         pos={`${index + 1}/${countProducts}`}/>
                    })
                }
            </div>
        )
    }
}

export default ShipItems
